// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__17JEV","col":"styles_col__3sPWy"};